import {AppActions, useAppContext} from "../context/AppContext";
import {Table, Tag, Typography} from "antd";
import React, {useEffect} from "react";
import AppColor from "../components/AppColor";

export default function SelectPlan({type}) {
    const {appContext, selection, dispatchProject, getS} = useAppContext()

    const loadProject = (id) => {
        const project = appContext?.projects?.find(x => x?.id === id)
        if(project) {
            const plan = project?.projectFiles[0]
            const surveys = project?.shapeFiles?.filter(x => x.hasSurveyData)
            const _selection = {
                ...selection,
                [type]: {
                    project,
                    plan,
                    river: plan?.rivers[0],
                    survey: {...(surveys?.length > 0 ? surveys[0] : {}),}
                }
            }

            dispatchProject({
                type: AppActions.SET_PROJECT_SELECTION,
                data: {
                    selection: _selection
                }
            })
        }
    }

    return (
        <div style={{display: 'flex', alignItems: 'start', gap: 8}}>
            <Table
                pagination={false}
                style={{width: 400}}
                size={'small'}
                dataSource={appContext?.projects}
                rowKey={'id'}
                columns={[
                    {
                        key: '1',
                        dataIndex: '2',
                        title: 'Projects',
                        render: (text, record) => (
                            <Typography.Link
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    color: selection[type]?.project?.id === record?.id ? AppColor.mainColor : 'black',
                                    fontWeight: selection[type]?.project?.id === record?.id ? 'bold' : '',
                                    cursor: 'pointer'
                                }}
                                onClick={() => loadProject(record?.id)}
                            >
                                <div style={{minWidth:300}}>{record?.information?.title}{selection[type]?.project?.id === record?.id ? <>&#x2022;</> : ''}</div> <Tag>{record?.modelType || 'Model A'}</Tag>
                            </Typography.Link>
                        )
                    }
                ]}
            />
            <Table
                pagination={false}
                style={{width: 300}}
                size={'small'}
                dataSource={selection[type]?.project?.projectFiles || []}
                rowKey={'id'}
                columns={[
                    {
                        key: '1',
                        dataIndex: '2',
                        title: `Plans: ${selection[type]?.project?.information?.title}`,
                        render: (text, record) => (
                            <>
                                <Typography.Link
                                    onClick={() => {
                                        dispatchProject({
                                            type: AppActions.SET_PROJECT_SELECTION,
                                            data: {
                                                selection: {
                                                    ...selection,
                                                    [type]: {
                                                        project: selection[type].project,
                                                        plan: {...record},
                                                        river: record?.rivers[0],
                                                        survey: selection[type].survey,
                                                    }
                                                }
                                            }
                                        })
                                    }}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 8,
                                        color: selection[type]?.plan?.id === record?.id ? AppColor.mainColor : 'black',
                                        fontWeight: selection[type]?.plan?.id === record?.id ? 'bold' : '',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {record?.type} {selection[type]?.plan?.id === record?.id ? <>&#x2022;</> : ''}
                                </Typography.Link>
                                <span style={{color: 'black'}}>{record?.plan?.fileName}</span>
                            </>
                        )
                    }
                ]}
            />
            {
                selection[type]?.plan?.rivers?.length > 0 && (
                    <Table
                        pagination={false}
                        style={{width: 300}}
                        size={'small'}
                        dataSource={selection[type]?.plan?.rivers || []}
                        rowKey={'id'}
                        columns={[
                            {
                                key: '1',
                                dataIndex: '2',
                                title: `Rivers: ${selection[type]?.plan?.type}`,
                                render: (text, record) => (
                                    <Typography.Link
                                        onClick={() => {
                                            dispatchProject({
                                                type: AppActions.SET_PROJECT_SELECTION,
                                                data: {
                                                    selection: {
                                                        ...selection,
                                                        [type]: {
                                                            project: selection[type].project,
                                                            plan: selection[type].plan,
                                                            river: {...record},
                                                            survey: selection[type].survey,
                                                        }
                                                    }
                                                }
                                            })
                                        }}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 8,
                                            color: AppColor.mainColor,
                                            fontWeight: selection[type]?.river?.key === record?.key ? 'bold' : '',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {record?.river} - {record?.reach}  {selection[type]?.river?.key === record?.key ? <>&#x2022;</> : ''}
                                    </Typography.Link>
                                )
                            }
                        ]}
                    />
                )
            }
            {
                selection[type]?.project?.shapeFiles?.filter(x => x.hasSurveyData)?.length > 0 && (
                    <Table
                        pagination={false}
                        style={{minWidth: 300}}
                        size={'small'}
                        dataSource={selection[type]?.project?.shapeFiles?.filter(x => x.hasSurveyData) || []}
                        rowKey={'id'}
                        columns={[
                            {
                                key: '1',
                                dataIndex: '2',
                                title: `Survey data: ${selection[type]?.survey?.title}`,
                                render: (text, record) => (
                                    <Typography.Link
                                        onClick={() => {
                                            dispatchProject({
                                                type: AppActions.SET_PROJECT_SELECTION,
                                                data: {
                                                    selection: {
                                                        ...selection,
                                                        [type]: {
                                                            project: selection[type].project,
                                                            plan: selection[type].plan,
                                                            river: selection[type].river,
                                                            survey: {...record}
                                                        }
                                                    }
                                                }
                                            })
                                        }}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 8,
                                            color: AppColor.mainColor,
                                            fontWeight: selection[type]?.survey?.id === record?.id ? 'bold' : '',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {record?.title}
                                    </Typography.Link>
                                )
                            }
                        ]}
                    />
                )
            }
        </div>
    )
}